import type { IconSvgObject } from './types';

const AlphabetKoreanIcon: IconSvgObject = [
  ["path", { d: "M5 6H12C12.5523 6 13.0026 6.44637 12.9787 6.99814C12.8041 11.0259 11.4478 16.8238 5 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 3V12M16 21V12M16 12H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AlphabetKoreanIcon;
